import React, { useEffect, useState, useRef } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import cr1 from "../images/cr1.png";
import cr2 from "../images/cr2.png";
import cr3 from "../images/cr3.png";
import cr4 from "../images/cr4.png";
import cr5 from "../images/cr5.png";
import cr6 from "../images/cr6.png";
import cr7 from "../images/cr7.png";
import cr8 from "../images/cr8.png";
import cr9 from "../images/cr9.png";
import cr10 from "../images/cr10.png";
import pr1 from "../images/pr1.jpg";
import pr2 from "../images/pr2.jpg";
import pr3 from "../images/pr3.jpg";

import axios from "axios";
import { API_URL } from "./Constant";
import { Avatar, Typography } from "@mui/material";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import Badge from "@mui/material/Badge";

import CircleIcon from "@mui/icons-material/Circle";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import Colors from "./Colors";

const pages = ["Home", "About us", "Contact us"];

const colors = ["#503259", "#4C50AE", "#FF7D6A", "#B07CC6", "#20C925"];

const creatorMap = {
  1: cr1,
  2: cr2,
  3: cr3,
  4: cr4,
  5: cr5,
  6: cr6,
  7: cr7,
  8: cr8,
  9: cr9,
  0: cr10,
};

function Header(props) {
  const { bg } = props;

  function getConsistentProfilePicture(images, userId) {
    // Generate a deterministic index using the user ID
    const index = userId % images.length;
    return images[index];
  }

  // Example usage
  const prpictures = [pr1, pr2, pr3];

  const dropDownRef = useRef(null);

  const [playerDetails, setPlayerDetails] = useState([]);
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [isSignOut, setIsSignOut] = useState(false);
  const [creatorDetails, setCreatorDetails] = useState([]);

  const handleSignInButtonClick = () => {
    window.location.href = "/player-signin";
  };

  

  

  const handleAvatarButtonClick = () => {
    setIsShowDropdown((prevState) => !prevState);
  };

  useEffect(() => {
    console.log("CreatorTocken", localStorage.getItem("CreatorTocken"));
    if (localStorage.getItem("CreatorTocken")) {
      console.log(localStorage.getItem("CreatorTocken"));
      const fetchUserData = async () => {
        try {
          const response = await axios.post(
            `${API_URL}/select_creator_details_with_tocken`,
            {
              CreatorTocken: localStorage.getItem("CreatorTocken"),
            },
          );
          console.log("setCreatorDetails", response.data.result);
          setCreatorDetails(response.data.result);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchUserData();
    }
  }, [localStorage.getItem("CreatorTocken")]);

  useEffect(() => {
    if (localStorage.getItem("PlayerTocken")) {
      const fetchSpData = async () => {
        try {
          const response = await axios.post(
            `${API_URL}/select_player_details_with_tocken`,
            {
              PlayerTocken: localStorage.getItem("PlayerTocken"),
            },
          );
          setPlayerDetails(response.data.result);
          localStorage.setItem("PlayerName", response.data.result.name);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchSpData();
      const intervalId = setInterval(fetchSpData, 1000);

      return () => clearInterval(intervalId);
    }
  }, [localStorage.getItem("PlayerTocken")]);

  const handleSignOutClick = () => {
    setIsSignOut(true);
  };

  const handleProfileClick = () => {
    window.location.href = "/profile";
  };
  //   localStorage.removeItem("CreatorTocken")
  //   localStorage.removeItem("PlayerTocken")
  //   localStorage.removeItem("BackToBenchTocken")
  //  localStorage.removeItem("RapidGame")
  const handleIsSignOutPopUpSignOutButtonClick = () => {
    if (localStorage.getItem("PlayerTocken")) {
      localStorage.removeItem("PlayerTocken");
    } else {
      localStorage.removeItem("CreatorTocken");
    }
    window.location.href = "/";
    setIsSignOut(false);
    localStorage.setItem("signout", Date.now());
    localStorage.removeItem("CreatorId");
  };

  window.addEventListener("storage", (event) => {
    if (event.key === "signout") {
      if (localStorage.getItem("PlayerTocken")) {
        localStorage.removeItem("PlayerTocken");
      } else {
        localStorage.removeItem("CreatorTocken");
      }
      window.location.href = "/";
    }
  });

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setIsShowDropdown(false); // Hide the box when clicking outside
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropDownRef, setIsShowDropdown]);

  const handleCloseIsSignOutPopUp = () => {
    setIsSignOut(false);
  };

  const handleCreateGameButtonClick = () => {
    window.location.href = "/creator-signin";
  };

  const colors = [
    "#dfb724",
    "#e25a44",
    "#c41876",
    "#16a550",
    "#1e7575",
    "#2f5180",
  ];

  function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colorIndex = Math.abs(hash) % colors.length;
    return colors[colorIndex];
  }

  function stringAvatar(name = "") {
    const initial = name.charAt(0).toUpperCase();

    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: initial || "",
    };
  }

  return (
    <AppBar
      position="static"
      sx={{
        height: { xs: "68px", md: "84px" },
        justifyContent: "center",
        width: "100%",
        background: Colors.headerBg,
        boxShadow: "0px 3px 3px 0px #00000040",
        alignItems: "center",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          height: { xs: "48px", md: "84px" },
          width: { xs: "98%", md: "96%" },
        }}
      >
        <Toolbar disableGutters sx={{ height: "100%" }}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            {/* <Box onClick={() => {localStorage.getItem("PlayerTocken")? window.location.href = "/sp-landing" : window.location.href = "/" }} sx={{width: { xs: '92px',sm: '170px', md: '15%' } , height: { xs: '46px', sm: '36px', md: '36px' }, display: { xs: 'none',sm: 'flex' ,md: 'flex' },
                justifyContent: 'center', alignItems: 'center',}}>
                <img src={logo} alt="Logo" style={{maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', cursor: 'pointer' }} />
                </Box>
                <Box onClick={() => {localStorage.getItem("PlayerTocken")? window.location.href = "/sp-landing" : window.location.href = "/" }} sx={{width: '36px' , height:  '36px', display: { xs:'flex',sm: 'none' , md:'none' },
                justifyContent: 'center', alignItems: 'center',}}>
                <img src={logomob} alt="Logo" style={{maxWidth: '100%', maxHeight: '100%',objectFit: '100% 100%', cursor: 'pointer'  }} />
                </Box> */}

            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                height: "100%",
                width: { xs: "30%", md: "70%" },
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "56px",
              }}
            >
              
              <Box
                onClick={() => {
                  localStorage.getItem("PlayerTocken")
                    ? (window.location.href = "/")
                    : (window.location.href = "/");
                }}
                sx={{
                  width: { xs: "160px", sm: "170px", md: "25%" },
                  height: { xs: "64px", sm: "36px", md: "74px" },
                  display: { xs: "flex", sm: "flex", md: "flex" },
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={logo}
                  alt="Logo"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "80%",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                />
              </Box>
            </Box>
            {!localStorage.getItem("CreatorTocken") &&
              !localStorage.getItem("PlayerTocken") &&
              !localStorage.getItem("BackToBenchTocken") &&
              !localStorage.getItem("TimelessTiesTocken") && (
                <Box
                  sx={{
                    width: { xs: "calc(100% - 110px)", md: "30%" },
                    height: { xs: "36px", md: "36px" },
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    gap: { xs: "8px", md: "16px" },
                  }}
                >
                  {/*              
               <Button 
        onClick={handleCreateGameButtonClick}
        sx={{
          background: '#5BC8AC',
          color: '#fff',
         width: 'fit-content',
          border: '1px solid #2A5E4F',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '12px',
          transition: 'background 0.3s, transform 0.3s',
          '&:hover': { 
            background: '#3D8A75',
            transform: 'scale(1.05)',
          },
          '&:active': {
            background: '#2A5E4F',
          },
        }}
      >
       Create a game
      </Button> */}
                  <Button
                    onClick={handleSignInButtonClick}
                    sx={{
                      background: Colors.avatarButton,
                      color: "#fff",
                      paddingLeft: "16px",
                      paddingRight: "16px",
                      width: "50%",
                      border: "1px solid ",
                      borderColor: Colors.avatarBorder,
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontSize: "12px",
                      transition: "background 0.3s, transform 0.3s",
                      // boxShadow: "0 6px 15px rgba(105, 59, 105, 0.8)",
                      "&:hover": {
                        background: Colors.avatarButton,
                        transform: "scale(1.05)",
                      },
                      "&:active": {
                        background: Colors.avatarButton,
                      },
                    }}
                  >
                    Sign in
                  </Button>
                </Box>
              )}

            {(localStorage.getItem("CreatorTocken") ||
              localStorage.getItem("PlayerTocken")) && (
              <>
                <Box
                  sx={{
                    width: { xs: "70%", md: "30%" },
                    height: { xs: "36px", md: "36px" },
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    gap: { xs: "12px", md: "16px" },
                  }}
                >
                  {localStorage.getItem("PlayerTocken") && (
                    <>
                      {/* <Avatar alt="profile"
                             src={getConsistentProfilePicture(prpictures, playerDetails.player_id) || pr1}                              
                              onClick={handleAvatarButtonClick}
                            sx={{  width: '38px', height: '38px', cursor: 'pointer', border:'1px solid white'}}/> */}
                      <Box
                        sx={{
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "row",
                          gap: "4px",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                          position: "relative",
                        }}
                        onClick={handleAvatarButtonClick}
                      >
                        <Avatar
                          {...stringAvatar(playerDetails.name)}
                          sx={{
                            width: "38px",
                            height: "38px",
                            fontSize: "20px",
                            bgcolor: Colors.avatarButton,
                          }}
                        />
                        <KeyboardArrowDownIcon
                          sx={{ fontSize: 22, color: "#503259" }}
                        />
                      </Box>
                      {/* { playerDetails.name && <Box onClick={handleAvatarButtonClick}
        sx={{
          background: Colors.avatarButton,
          color: "#fff",
          width: "fit-content",
          padding: "8px 12px",
          border: "1px solid ",
          borderColor: Colors.avatarButton,
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "14px", fontWeight:600,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          transition: "background 0.3s, transform 0.3s",
          "&:hover": {
            background: Colors.avatarButton,
            transform: "scale(1.05)",
          },
          "&:active": {
            background: Colors.avatarButton,
          },
        }}
      >
       {playerDetails.name}
      </Box>} */}

                      {isShowDropdown && (
                        <Box
                          ref={dropDownRef}
                          sx={{
                            position: "absolute",
                            top: "100%",
                            width: { xs: "150px", md: "200px" },
                            right: "0px",
                            borderRadius: "4px",
                            marginTop: "2px",
                            padding: { xs: "4px", md: "10px" },
                            backgroundColor: "#FFF",
                            zIndex: 999,
                            boxShadow: "0px 4px 4px 0px #00000040",
                            gap: { xs: "0px ", md: "4px" },
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
 <Box
                            sx={{
                              padding: { xs: "4px 10px", md: "4px 10px" },
                              cursor: "pointer",
                              borderRadius: "4px",
                              color: "#000",
                              zIndex: 999,
                              "&:hover": {
                                background: Colors.Tidesbg,
                                 fontWeight:600,
                                 fontFamily: "Boogaloo",
                              },
                            }}
                            onClick={handleProfileClick}
                          >
                            <Typography
                              sx={{
                                maxWidth: "98%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                color: "inherit",
                                fontWeight:"inherit",
                                 fontFamily:"inherit",
                              }}
                            >
                              My Profile
                            </Typography>
                          </Box>


                          <Box
                            sx={{
                              padding: { xs: "4px 10px", md: "4px 10px" },
                              cursor: "pointer",
                              borderRadius: "4px",
                              color: "#000",
                              zIndex: 999,
                             "&:hover": {
                                background: Colors.Tidesbg,
                                 fontWeight:600,
                                 fontFamily: "Boogaloo",
                              },
                            }}
                            onClick={handleSignOutClick}
                          >
                            <Typography
                              sx={{
                                maxWidth: "98%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                color: "inherit",
                                fontWeight:"inherit",
                                 fontFamily:"inherit",
                              }}
                            >
                              Sign out
                            </Typography>
                          </Box>

                         
                        </Box>
                      )}
                    </>
                  )}

                  {localStorage.getItem("CreatorTocken") &&
                    creatorDetails.creator_id && (
                      <>
                        <Box
                          sx={{ position: "relative", display: "inline-block" }}
                        >
                          {/* <Avatar alt="profile"
                            src={ creatorMap[creatorDetails.creator_id?.toString()[0] || '0'] || pr1} 
                            onClick={handleAvatarButtonClick}
                            sx={{  width: '32px', height: '32px', cursor: 'pointer', border:'4px solid white' }}/> */}
                          {creatorDetails.name && (
                            <Box
                              onClick={handleAvatarButtonClick}
                              sx={{
                                background: Colors.tab1color,
                                color: "#fff",
                                width: "fit-content",
                                padding: "8px 12px",
                                border: "1px solid ",
                                borderColor: Colors.tab1color,
                                borderRadius: "8px",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: 600,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                transition: "background 0.3s, transform 0.3s",
                                "&:hover": {
                                  background: Colors.tab1color,
                                  transform: "scale(1.05)",
                                },
                                "&:active": {
                                  background: Colors.tab1color,
                                },
                              }}
                            >
                              {creatorDetails.name}
                              <ArrowDropDownIcon />
                            </Box>
                          )}
                        </Box>

                        {isShowDropdown && (
                          <Box
                            ref={dropDownRef}
                            sx={{
                              position: "absolute",
                              top: "100%",
                              width: { xs: "150px", md: "200px" },
                              right: "0px",
                              borderRadius: "4px",
                              marginTop: "4px",
                              padding: { xs: "4px", md: "10px" },
                              backgroundColor: "#FFF",
                              zIndex: 999999,
                              boxShadow: "0px 4px 4px 0px #00000040",
                              gap: { xs: "0px ", md: "4px" },
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Box
                              sx={{
                                padding: { xs: "4px 10px", md: "4px 10px" },
                                cursor: "pointer",
                                borderRadius: "4px",
                                color: "#000",
                                zIndex: 99999999,
                                "&:hover": {
                                  backgroundColor: Colors.bgColor,
                                  color: "#202f75",
                                },
                              }}
                              onClick={handleSignOutClick}
                            >
                              <Typography
                                sx={{
                                  maxWidth: "98%",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  color: "inherit",
                                }}
                              >
                                Sign out
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </>
                    )}
                </Box>
              </>
            )}
          </Box>
        </Toolbar>
      </Container>

      {isSignOut && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              gap: "5px",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                width: { md: "25%", sm: "25%", xs: "85%" },
                height: "36px",
                justifyContent: "right",
                alignItems: "right",
                display: "flex",
              }}
            >
              <IconButton
                onClick={handleCloseIsSignOutPopUp}
                sx={{
                  position: "fixed",
                  width: "36px",
                  height: "36px",
                }}
              >
                <CloseOutlinedIcon
                  sx={{
                    width: "36px",
                    height: "36px",
                    color: "#F9F9F9",
                    "&:hover": {
                      width: "40px",
                      height: "40px",
                      color: "#F9F9F9",
                      backgroundColor: "none",
                      background: "none",
                    },
                  }}
                ></CloseOutlinedIcon>
              </IconButton>
            </Box>
            <Box
              sx={{
                width: { md: "25%", sm: "25%", xs: "85%" },
                height: "fit-content",
                background: Colors.Tidesbg,
                border: "1px solid",
                borderColor: "#FFF",
                borderRadius: "16px ",
                boxShadow: "none",
                boxSizing: "border-box",
                zIndex: 99999,
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  gap: "16px",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    gap: "16px",
                    paddingTop: "13%",
                    justifyContent: "center",
                    alignContent: "center",
                    height: "86%",
                    maxWidth: "75%",
                    paddingBottom: "13%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      gap: "20px",
                      justifyContent: "center",
                      alignContent: "center",
                      height: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Typography sx={{ fontSize: "24px", color: "#000" }}>
                      Sign out
                    </Typography>

                    <Typography sx={{ textAlign: "center", color: "#000" }}>
                      Are you sure you would like to sign out your account?
                    </Typography>
                    <Box
                      sx={{
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                        gap: { xs: "8px", md: "16px" },
                      }}
                    >
                      <Button
                        onClick={handleCloseIsSignOutPopUp}
                        sx={{
                          background: Colors.button1,
                          color: Colors.button1font,
                          width: "120px",
                          border: "1px solid",
                          borderColor: Colors.button1Border,
                          borderRadius: "8px",
                          cursor: "pointer",
                          fontSize: "12px",
                          transition: "background 0.3s, transform 0.3s",
                          "&:hover": {
                            background: Colors.button1,
                            transform: "scale(1.05)",
                          },
                          "&:active": {
                            background: Colors.button1,
                          },
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={handleIsSignOutPopUpSignOutButtonClick}
                        sx={{
                          background: Colors.button2,
                          color: Colors.button2font,
                          width: "120px",
                          border: "1px solid",
                          borderColor: Colors.button2Border,
                          borderRadius: "8px",
                          cursor: "pointer",
                          fontSize: "12px",
                          transition: "background 0.3s, transform 0.3s",
                          "&:hover": {
                            background: Colors.button2,
                            transform: "scale(1.05)",
                          },
                          "&:active": {
                            background: Colors.button2,
                          },
                        }}
                      >
                        Sign out
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </AppBar>
  );
}

export default Header;
